import initializeMobileMenu from './menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeLazyYoutube from "./utils/lazy-youtube";
import initializeHeaderScroll from './header-scroll';
import initializePolylangSelect from './polylang-select';
import initializeExternalLinks from './utils/external-links';
import initializeBoxElement from './blocks/box-element';
import initializeBoxAnimatedNumber from './blocks/box-animated-number';

import initializeAccordions from "./blocks/accordion";
// import initializeIconBoxes from './blocks/icon-boxes';
// import initializeNumbersBlock from './blocks/numbers';
// import initializeGallerySection from './blocks/gallery-section';
// import initializeGalleryGrid from "./blocks/gallery-grid";
// import initializeBrands from './blocks/brands';
// import initializeGallerySlider from './blocks/gallery-slider';
// import initializeGalleryText from './blocks/gallery-text';
import initializeImageSlider from './blocks/image-slider';
import initializeBoxSlider from "./blocks/box-slider";
import initializeLogoSlider from "./blocks/logo-slider";
import initializePostList from "./blocks/post-list";
import initializeLandingPage from "./landing-page";
import initializeJobOffersList from "./blocks/job-offers-list";
import initializeJobOffersLatest from "./blocks/job-offers-latest";
import initializeBoxElementIconSlider from "./blocks/box-element-icon-slider";
import initializeTimeline from "./blocks/timeline";
import initializeTestimonials from "./blocks/testimonials";
import initializeWorldMapLocations from "./blocks/world-map-locations";
// import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        initializeExternalLinks();
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeFiles();
        initializeLazyYoutube();
        initializeHeaderScroll();
        initializePolylangSelect();
        initializeBoxElement();
        initializeBoxAnimatedNumber();
        initializeBoxSlider();
        initializeLogoSlider();

        initializeAccordions();
        initializePostList();
        initializeLandingPage();
        initializeJobOffersList();
        initializeJobOffersLatest();
        initializeBoxElementIconSlider();
        initializeTimeline();
        initializeTestimonials();
        initializeWorldMapLocations();
        // initializeCollapse();
        // initializeIconBoxes();
        // initializeNumbersBlock();
        // initializeGallerySection();
        // initializeGalleryGrid();
        // initializeBrands();
        // initializeGallerySlider();
        // initializeGalleryText();
        // initializeIconBoxesAnimation();
        initializeImageSlider();

        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
